import React from 'react'
import './LCL.css'

function LCL() {
  return (
    <div className="lcl-services-container">
      {/* Hero section with image and overlay text */}
      <div className="lcl-services-hero">
        <div className="lcl-services-overlay">
          <h1>LCL Consolidation & Warehousing</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Content section */}
      <div className="lcl-content">
        <div className="lcl-image">
          <img src="/Pics/blog.jpg" alt="LCL Consolidation & Warehousing Services" />
        </div>
        
        <p>
          Centrex Marine Services is a trusted logistics provider, offering a comprehensive range of services to meet the diverse needs of our clients. With expertise in LCL consolidation, warehousing, and more, we help businesses streamline their supply chains, reduce costs, and improve efficiency.
        </p>
        
        <p>
          <strong>Our Services</strong>
        </p>
        
        <p>
          - LCL Consolidation: Optimize container space and reduce costs with our LCL consolidation services.
        </p>
        
        <p>
          - Warehousing: Store your goods securely and efficiently with our state-of-the-art warehousing facilities.
        </p>
        
        <p>
          - Other logistics services: From transportation to customs clearance, we offer a full suite of logistics solutions to meet your needs.
        </p>
        
        <p>
          <strong>Why Choose Centrex Marine Services?</strong>
        </p>
        
        <p>
          - Expertise: Our team has extensive experience in logistics and supply chain management.
        </p>
        
        <p>
          - Reliability: We pride ourselves on our ability to deliver high-quality services and meet our clients' needs.
        </p>
        
        <p>
          - Flexibility: We tailor our services to meet the unique requirements of each client.
        </p>
        
        <p>
          By partnering with Centrex Marine Services, businesses can benefit from our expertise, reliability, and flexibility, improving their logistics operations and achieving their goals.
        </p>
      </div>
    </div>
  )
}

export default LCL
